module.exports = __webpack_public_path__ + "static/media/step_3_rules.e46b91df.png";